import InstallationReview from '../../installation/partial/review'
import { parseDict } from '@/util/dicts'
import global from '@/util/mixin/global'

export default {
  props: ['id'],
  mixins:[global],
  data() {
    return {
      columns: [{
          title: '类型',
          key: 'installTypeText',
          minWidth: 120,
        },
        {
          title: '提交人',
          key: 'repairUserName',
          minWidth: 180,
        },
        {
          title: '提交时间',
          key: 'reformDatetimeText',
          minWidth: 130,
        },
        {
          title: '状态',
          key: 'stateText',
          minWidth: 100,
        },
        
        {
          title: '操作',
          key: 'action',
          width: 120,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let acts = [
              <a on-click={()=>this.view(row)}>查看</a>
            ]

            if(row.state == 2 && this.isAdmin ){
              acts.push( <a on-click={()=>this.view(row , true)}>审核</a> )
            }
            return this.$utils.link(acts, <Divider type="vertical" />)
          }
        }
      ],
      data: [],
      loading: false,
    }
  },

  created() {
    this.$watch('id' , function(nv){
      if(nv){
        this.query()
      }else{
        this.data = []
      }
    },{immediate:true})
  },

  methods: {
    review(){
      
    },
    query(){
      this.$request.stdCarInstallation(this.id).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data || [], {'reformDatetime':'datetime', 'state': 'stdInstallationState' , 'installType':'stdInstallationType'})
        }
      })
    },
    view(row , review = false) {
      this.$dialog({
        title:row.installTypeText+'单',
        width:550,
        paddingless:true,
        render:(h)=>{
          return <InstallationReview id={row.id} enable={review} />
        },
        onOk:()=>{
          this.search()
        }
      })
    },

    handleUpdate() {

    },

  },
  render() {
    return (
      <div class="pg-bd">
        <sl-table showHeader={true} loading={this.loading} page={false} columns={this.columns} data={this.data}>
        </sl-table>
      </div>
    )
  }
}
